import * as keys from './keys'

export default {
  [keys.HELLO]: 'Ciao'
}
